import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";

export const fetchProviderSearchSuggestions = createAsyncThunk(
  "fetchProviderSearchSuggestions",
  async (searchParams) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers?view=search&field=(all)&query=${searchParams.query}&page-number=${searchParams.pageNumber}&page-size=10`
    );
    return result;
  }
);

export const fetchPracticeSearchSuggestions = createAsyncThunk(
  "fetchPracticeSearchSuggestions",
  async (searchParams) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices?field=all&page-number=${searchParams.pageNumber}&page-size=10&query=${searchParams.query}&view=search`
    );
    return result;
  }
);